import React from 'react';
export function Footer() {
  return <footer className="w-full bg-black border-t border-[#FF6B00]/20 py-10 px-4" data-id="element-171">
      <div className="max-w-3xl mx-auto text-center" data-id="element-172">
        <div className="text-[#FF6B00] text-2xl font-black tracking-widest mb-4" data-id="element-173">
          🥁 PROFEPACK™
        </div>
        <p className="text-gray-400 text-sm leading-relaxed mb-4 max-w-xl mx-auto" data-id="element-174">
          El sistema de clases N°1 para profesores de folklore en Argentina.
        </p>
        <p className="text-gray-400 text-sm italic mb-6" data-id="element-175">
          Porque enseñar folklore no debería costarte todos los domingos del
          año.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-sm text-gray-300 mb-6" data-id="element-176">
          <span data-id="element-177">📧 soporteprofepack@gmail.com</span>
          <span className="hidden sm:inline" data-id="element-178">•</span>
          <span data-id="element-179">📲 @profepack</span>
          <span className="hidden sm:inline" data-id="element-180">•</span>
          <span data-id="element-181">🌐 www.profepack.com</span>
        </div>

        <div className="h-px bg-[#FF6B00]/20 mb-6" data-id="element-182" />
        <p className="text-gray-400 text-xs mb-2" data-id="element-183">
          © ProfePack™ 2025 — Todos los derechos reservados.
        </p>
        <p className="text-gray-500 text-xs mb-6" data-id="element-184">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}